import moment from "moment";
import { cloneDeep } from 'lodash';

export class PlanStatusDTO {
    PlanId: string;
    PlanName: string;
    TotalSegments: number;
    CompletedEvals: number;
    StartDate: Date;
    EndDate: Date;
    Appealed: number;
    Completed: number;
    Expired: number;
    Pending: number;
    Deleted: number;
    Replaced: number;
    AppealedExpired: number;
    CompletedDeleted: number;
    OnTrackPercentage: number;
};

export class PlanStatus extends PlanStatusDTO {
    constructor(dto: PlanStatusDTO) {
        super();
        this.PlanId = dto.PlanId;
        this.PlanName = dto.PlanName;
        this.TotalSegments = dto.TotalSegments;
        this.CompletedEvals = dto.CompletedEvals;
        this.StartDate = dto.StartDate;
        this.EndDate = dto.EndDate;
        this.Appealed = dto.Appealed;
        this.Completed = dto.Completed;
        this.Expired = dto.Expired;
        this.Pending = dto.Pending;
        this.Deleted = dto.Deleted;
        this.Replaced = dto.Replaced;
        this.AppealedExpired = dto.AppealedExpired;
        this.CompletedDeleted = dto.CompletedDeleted;
        let start = new Date(dto.StartDate);
        start.setHours(0);
        start.setMinutes(0);
        start.setSeconds(0);
        start.setMilliseconds(0);
        let end = new Date(dto.EndDate);
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        end.setMilliseconds(999);
        let today = new Date();
        today.setHours(23);
        today.setMinutes(59);
        today.setSeconds(59);
        today.setMilliseconds(999);

        this.WrkDays = moment(end).diff(moment(start), "days") + 1;
        this.RemainingWrkDays = moment(end).diff(moment(today), "days") + 1;
        this.ElapsedWrkDays = moment(today).diff(moment(start), "days") + 1;
        // onTrack information is retrieved from BE response
        this.OnTrack = dto.OnTrackPercentage;
    }

    WrkDays: number;
    RemainingWrkDays: number;
    ElapsedWrkDays: number;
    OnTrack: number;
}

export interface PlanStatusSelection {
    PlanId: string;
    PlanName: string;
}

export const StatusKeys = {
    Appealed: 'Appealed',
    Completed: 'Completed',
    Expired: 'Expired',
    Pending: 'Pending',
    Deleted: 'Deleted',
    AppealedExpired: 'AppealedExpired',
    CompletedDeleted: 'CompletedDeleted',
    Replaced: 'Replaced'
}

export const PlanStatusConstants = {
    maxPlanStatus: 5
};

export const LegendColors = {
    Appealed: "#BA70B6",
    Completed: "#99A5D9",
    Expired: "#BE9170",
    Pending: "#70A2AE",
    Deleted: "#BDC576",
    Replaced: "#6F7FC0",
    AppealedExpired: "#A8AEB4",
    CompletedDeleted: "#9E4B96"
}